var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('website-sprite'),_c('website-header'),_c('base-view'),_c('website-footer'),_c('presale-chat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }